import { Injectable } from '@angular/core';
import { DocumentFile } from '@app/models';
import { CreateSuccess } from '@briebug/ngrx-auto-entity';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { map, exhaustMap } from 'rxjs/operators';
import { createAction, props, Store } from '@ngrx/store';
import {
  CreateDocumentFilePayload,
  DocumentFileService,
} from '@services/api/document-file.service';
import * as uuid from 'uuid';
import { AppState } from '.';
import { EMPTY } from 'rxjs';

export const createDocumentFile = createAction(
  '[Document File] Create',
  props<{ payload: CreateDocumentFilePayload }>()
);

export const uploadDocumentFile = createAction(
  '[Document File] Upload',
  props<{ payload: CreateDocumentFilePayload }>()
);

@Injectable()
export class DocumentFileEffects {
  createDocument$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createDocumentFile),
        map(action => action.payload),
        exhaustMap(payload => {
          const progressId = uuid();
          return this.docService.create(payload.documentFile).pipe(
            map(response => {
              this.store$.dispatch(new CreateSuccess(DocumentFile, response));
              const newPayload: CreateDocumentFilePayload = {
                documentFile: response,
                file: payload.file,
              };
              this.store$.dispatch(uploadDocumentFile({ payload: newPayload }));
            })
            // catchError(error => {
            //   console.log(error);
            // })
          );
        })
      ),
    { dispatch: false }
  );

  uploadDocument$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(uploadDocumentFile),
        map(action => action.payload),
        exhaustMap(payload => {
          const progressId = uuid();
          this.docService.uploadFile(payload);
          return EMPTY;
          // .pipe(
          //   map(completed => {
          //     if (completed) {
          //       const jobDocument: JobDocument = {
          //         ...payload.jobDocument,
          //         fileExists: true,
          //       };
          //       this.store$.dispatch(new Update(JobDocument, jobDocument));
          //     }
          //   })
          // );
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private docService: DocumentFileService,
    private store$: Store<AppState>
  ) {}
}
